import React from "react";
import { useState, useEffect, useRef } from 'react'
import { supabase } from "../supabaseClient";
import { Button, Form, Modal, Row, Alert, ButtonGroup } from "react-bootstrap";
import { FilePlus } from 'react-bootstrap-icons';
import IconPicker from "../components/IconPicker";
import InputGroup from 'react-bootstrap/InputGroup';

const MyModalForCreatingTabulations = (props) => {
    const { selectedRowValues, tabulations, whenfinished } = props;
    const titleRef = useRef(null);
    const dbString = useRef(null);
    const multiRefEnableRef = useRef(null);
    const [loading, setLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState("");

    const [iconSelected, setIconSelected] = useState(null);
    const [currentRow, setCurrentRow] = useState(null);

    useEffect(() => {
        const fixCurrentRow = () => {
            let currentRow = null;
            if( selectedRowValues && selectedRowValues.length > 0 && tabulations){
                //console.log("Selected Row Value = " + selectedRowValues[0])
                currentRow = tabulations.find((element) => element.id === selectedRowValues[0]);
                console.log(currentRow);
                if(currentRow){
                    //console.log("(modalForCreate)Current Row = " + currentRow.id + " - " + currentRow.title + " - " + currentRow.subtitle + " - " + currentRow.numero_court + " - " + currentRow.numero + " - " + currentRow.iconname + " - " + currentRow.icontype + " - " + currentRow.ordre);
                    console.log(currentRow);    
                } else {
                    currentRow = null;
                }
            };
            setCurrentRow(currentRow);
        }
        fixCurrentRow();
    }, [tabulations, selectedRowValues]);

    const getIconForm = () => {
        let anIcon = {};
            if(iconSelected){
                anIcon = iconSelected;
            } else if (currentRow?.iconname && currentRow?.icontype){
                anIcon = {iconName: currentRow?.iconname, iconType: currentRow?.icontype};
            } else {
                anIcon = {iconName: 'user-md', iconType: 'awsome'};
            }
            //console.log("((modalForCreatePB))Icon selected = " + anIcon.iconName + " - " + anIcon.iconType);
            return anIcon;
    }

    const handleSubmitCreateTel = async (e) => {
        e.preventDefault();
        createTabulation();
        if(whenfinished) whenfinished();
    }

    const createTabulation = async () => {
        try {
            setErrorMsg("");
            setLoading(true);

            if (!titleRef.current?.value || !dbString.current?.value ) {
                setErrorMsg("Informations manquantes !");
                setLoading(false);
                return;
            }

            //Where to put this new item - First check if there is a selected row
            var ordreToInsert = 0;
            if( currentRow ){
                ordreToInsert = currentRow.ordre + 0.5;
            } else 
            {
                setErrorMsg("Pas de ligne sélectionnée pour ajouter un numéro de téléphone - Ajouté en première position par défaut");
                setLoading(false);
                ordreToInsert = 0.5;
            };

            //Check Icon:
            let anIcon = getIconForm();

            console.log("(CreateTabulation)Create tabulations in db. ");
                let { data, error } = await supabase
                    .from('tabulations')
                    .insert({ 
                            'title': titleRef.current?.value, 
                            'currentversion': 1,
                            'dbstring': dbString.current?.value,
                            'iconname': anIcon.iconName,
                            'icontype': anIcon.iconType,
                            'ordre': ordreToInsert,
                            'usemultiref': multiRefEnableRef.current?.checked,
                         })
                    .select()
    
                if (error) {
                    console.warn(error)
                } else if (data) {
                    console.log(data);
                }
            
        } catch (error) {
            setErrorMsg(error);
        }
        setLoading(false);
    };


    return (
        <>
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Créer une tabulation
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitCreateTel}>
                    <Row className="mb-3">

                        <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon2">Titre</InputGroup.Text>
                        <Form.Control type="text" ref={titleRef} defaultValue={currentRow ? currentRow.title : null} required />
                        </InputGroup>

                        <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon2">DbString</InputGroup.Text>
                        <Form.Control type="text" ref={dbString} defaultValue={currentRow ? currentRow.dbstring : null} required />
                        </InputGroup>

                        <InputGroup className="mb-3">
                        <Form.Check type="switch" ref={multiRefEnableRef} defaultChecked={true} />
                        <Form.Check.Label>Active les références sur l'annuaire principal</Form.Check.Label>
                        </InputGroup>

                        <IconPicker callback={ 
                            (icon) => {
                                console.log("Choosed " + icon.iconName + " - " +icon.iconType);
                                setIconSelected(icon);
                            } 
                            } initialIcon={getIconForm()}/>
                    </Row>
                    {errorMsg && (
                        <Alert
                            variant="danger"
                            onClose={() => setErrorMsg("")}
                            dismissible>
                            {errorMsg}
                        </Alert>
                    )}
                    <div className="text-center mt-2">
                        <ButtonGroup>
                            <Button disabled={loading} type="submit" className="w-50"><FilePlus size={32}/>Ajouter</Button>
                        </ButtonGroup>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
        </>

    );
}

export default MyModalForCreatingTabulations;